import { ReactElement } from "react";
import ArrowIcon from "lib/svgs/Arrow";
import Text, { TextType } from "components/Text_DEPRECATED";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  margin-top: 0px;
  padding-top: 40px;
  align-items: center;
  cursor: hover;
`;

const ArrowContainer = styled.div``;

interface OwnProps {
  goBackHandler?: () => void;
  text: string;
}

export default function Breadcrumb(props: OwnProps): ReactElement {
  const handleGoBack = () => {
    props.goBackHandler && props.goBackHandler();
  };

  return (
    <Container>
      <ArrowContainer onClick={handleGoBack}>
        <ArrowIcon />
      </ArrowContainer>
      <Text
        style={{ cursor: "pointer", marginLeft: "8px" }}
        onClick={handleGoBack}
        type={TextType.PARAGRAPH}
      >
        {props.text}
      </Text>
    </Container>
  );
}
